import { AppData, BookingData, BookingTool, Step } from "../../AppDataProvider";
import {
  ResourceAllocationType,
  ResourceSelectionMode,
} from "../../../GeneratedGraphQL";
import { CompletePricePointsStepPayload } from "../../actions";
import { Mixpanel } from "../../../mixpanel";

export type CompletePricePointsStepOpts = {
  appData: AppData;
  payload: CompletePricePointsStepPayload;
};

const getNextStep = (
  bookingData: BookingData,
  bookingTool: BookingTool,
): Step => {
  const resourceSelectionBeforeAvailability =
    bookingData.organisation?.resourceSelectionBeforeAvailability;

  /**
   * If we have been provided a resourceId in the url params,
   * we want to navigate to the resources step where the
   * provided resource will be automatically selected
   */
  const urlParams = new URLSearchParams(window.location.search);
  const preFillResourceId = urlParams.get("resourceId");
  const resourcesOnService = bookingData.service?.numberOfResources;

  return bookingTool.resourceSelectionMode !== ResourceSelectionMode.Disabled &&
    resourceSelectionBeforeAvailability &&
    !preFillResourceId &&
    resourcesOnService &&
    resourcesOnService > 1 &&
    bookingData.service?.resourceAllocationType === ResourceAllocationType.Any
    ? "resources"
    : "availability";
};

export const completePricePointsStep = ({
  appData,
  payload,
}: CompletePricePointsStepOpts): AppData => {
  Mixpanel.track({ name: "Completed step", props: { step: "pricePoints" } });

  const { bookingData, bookingTool } = appData;
  const { pricePoints } = payload.updatedData;

  const attendees = pricePoints.reduce(
    (accumulator, pricePoint) =>
      accumulator +
      pricePoint.pricePoint.spacesPerQuantity * pricePoint.quantity,
    0,
  );

  const updatedBookingData = {
    ...bookingData,
    attendees,
    pricePoints,
  };

  return {
    ...appData,
    bookingData: updatedBookingData,
    currentStep: getNextStep(bookingData, bookingTool),
  };
};
